// generated from 1_287 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const receivedCampaignVariantFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("received_campaign_variant_filter"),
  comparison_key: z.enum([
    "7", // 930 (72.26%)
    "8", // 357 (27.74%)
  ]),
  display_name: z.object({
    data: z.array(
      z.object({
        id: common.objectId,
        name: z.string(),
      })
    ),
    // true 232 (18.03%), false 1_055 (81.97%)
    expired: z.boolean(),
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 552 (42.89%), defined 735 (57.11%)
  raw_value: common.objectId.optional(),
  value: z.object({
    id: common.objectId,
    name: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
